import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '@stores/translationStore';
import { useDomainStore } from '@stores/domainStore';
import './PaymentCallbackPage.scss';

type CallbackStatus = 'success' | 'error' | 'cancelled';

export default function PaymentCallbackPage() {
  const { t } = useTranslation();
  const { getBasePath } = useDomainStore();
  const navigate = useNavigate();

  // Determine callback type from the URL path
  const isSuccess = window.location.pathname.includes('/payment/success');
  const isCancel = window.location.pathname.includes('/payment/cancel');

  const [status] = useState<CallbackStatus>(
    isSuccess ? 'success' : isCancel ? 'cancelled' : 'error'
  );

  // Clean up any stale payment context
  useEffect(() => {
    sessionStorage.removeItem('gcxp_payment');
  }, []);

  const goToFolio = () => {
    const basePath = getBasePath();
    navigate(`${basePath}/folio`);
  };

  return (
    <div className="payment-callback">
      <div className="payment-callback__card">
        {/* Success */}
        {status === 'success' && (
          <div className="payment-callback__result">
            <span className="payment-callback__icon payment-callback__icon--success">✅</span>
            <h2 className="payment-callback__title">
              {t('payment.success') || 'Payment Successful'}
            </h2>
            <p className="payment-callback__subtitle">
              {t('payment.successMessage') || 'Your payment has been processed successfully.'}
            </p>
            <div className="payment-callback__save-done">
              <span>💳 {t('payment.cardSavedAuto') || 'Your card has been saved for faster future payments.'}</span>
            </div>
            <button className="payment-callback__btn payment-callback__btn--primary" onClick={goToFolio}>
              {t('payment.backToFolio') || 'Back to Folio'}
            </button>
          </div>
        )}

        {/* Error */}
        {status === 'error' && (
          <div className="payment-callback__result">
            <span className="payment-callback__icon payment-callback__icon--error">❌</span>
            <h2 className="payment-callback__title">
              {t('payment.failed') || 'Payment Failed'}
            </h2>
            <p className="payment-callback__subtitle">
              {t('payment.failedMessage') || 'Something went wrong with your payment. Please try again.'}
            </p>
            <button className="payment-callback__btn payment-callback__btn--primary" onClick={goToFolio}>
              {t('payment.tryAgain') || 'Back to Folio'}
            </button>
          </div>
        )}

        {/* Cancelled */}
        {status === 'cancelled' && (
          <div className="payment-callback__result">
            <span className="payment-callback__icon payment-callback__icon--cancel">🚫</span>
            <h2 className="payment-callback__title">
              {t('payment.cancelled') || 'Payment Cancelled'}
            </h2>
            <p className="payment-callback__subtitle">
              {t('payment.cancelledMessage') || 'You cancelled the payment. No charges were made.'}
            </p>
            <button className="payment-callback__btn payment-callback__btn--primary" onClick={goToFolio}>
              {t('payment.backToFolio') || 'Back to Folio'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
